
import React, { createContext, useContext } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

// Defined once at module scope so the array reference never changes
// across renders (required by @react-google-maps/api to avoid re-init).
const LIBRARIES = ["places"];

const GoogleMapsContext = createContext({ isLoaded: false, loadError: undefined });

// Single shared Google Maps script loader for the entire app.
// Mount this ONCE at the root so every consumer (RegionDropdown, Map, etc.)
// reads from the same loader instance instead of injecting the script
// multiple times (which causes "Element already defined" / "loaded
// multiple times" console errors).
const GoogleMapsProvider = ({ children }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries: LIBRARIES,
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMapsLoader = () => useContext(GoogleMapsContext);

export default GoogleMapsProvider;
